import { createApiClient } from './apiClient'
import {
  AdminUser,
  AdminUserDetail,
  AiUsageSummary,
  CreateUserPayload,
  UpdateUserPayload,
  ResetPasswordPayload,
} from '../types/auth'
import { PaginatedResponse } from '../types/catalog'

export const userService = (token: string | null) => {
  const api = createApiClient(token)

  return {
    get: (id: string) => api.get<AdminUserDetail>(`/api/users/${id}`),

    /** from/to: YYYY-MM-DD, inclusive, UTC */
    aiUsage: (id: string, from: string, to: string) =>
      api.get<AiUsageSummary>(`/api/users/${id}/ai-usage?from=${from}&to=${to}`),

    list: (page: number, perPage: number) =>
      api.get<PaginatedResponse<AdminUser>>(`/api/users?page=${page}&perPage=${perPage}`),

    create: (data: CreateUserPayload) => api.post<AdminUser>('/api/users', data),

    update: (id: string, data: UpdateUserPayload) => api.put<AdminUser>(`/api/users/${id}`, data),

    resetPassword: (id: string, data: ResetPasswordPayload) =>
      api.post<{ message: string }>(`/api/users/${id}/reset-password`, data),

    clearIntegration: (id: string, provider: 'google' | 'apple') =>
      api.delete<void>(`/api/users/${id}/integrations/${provider}`),

    deactivate: (id: string) => api.delete<void>(`/api/users/${id}`),
  }
}
